// Frontend mirror of backend/utils.py normalize_image_url — keeps the storefront
// resilient if any product row in the DB still has a raw Drive share URL.
const DRIVE_PATTERNS = [
  /https?:\/\/drive\.google\.com\/file\/d\/([\w-]+)/i,
  /https?:\/\/drive\.google\.com\/open\?id=([\w-]+)/i,
  /https?:\/\/drive\.google\.com\/uc\?(?:[^=]+=[^&]+&)*id=([\w-]+)/i,
];

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export function normalizeImageUrl(url) {
  if (!url || typeof url !== "string") return url || "";
  const u = url.trim();
  for (const pat of DRIVE_PATTERNS) {
    const m = u.match(pat);
    if (m) return `https://lh3.googleusercontent.com/d/${m[1]}=w1200`;
  }
  // Backend-served upload paths (/api/uploads/foo.jpg) — prefix with backend host so
  // they work both in preview and on the deployed domain.
  if (u.startsWith("/api/uploads/")) return `${BACKEND}${u}`;
  return u;
}
